import comp from "./SuggestedPrompts";
export default comp;
